// src/components/headerone/bots/EightByEightBot.js
// 8x8 AI Studio widget (bot-enabled).
// Replaces the legacy 8x8 webchat (chatv3.js) loader. The AI Studio widget is a
// self-contained, bot-enabled product: it renders its own launcher and manages its
// own UI/state, so the old custom launcher, icon override, and window.chatApp
// customer-info sync are no longer applicable and have been removed.
import React, { useEffect } from 'react';

const WIDGET_ID = 'wgt_grain_92043a6e';
const LOADER_SRC = 'https://widget.8x8.studio/v1/ai-studio-widget.js';
const LOADER_ID = 'eightbyeight-ai-studio-loader';
const WIDGET_TAG = 'ai-studio-widget';

function EightByEightBot() {
  useEffect(() => {
    // Inject the AI Studio widget custom element if it isn't already present.
    let widget = document.querySelector(`${WIDGET_TAG}[widget-id="${WIDGET_ID}"]`);
    if (!widget) {
      widget = document.createElement(WIDGET_TAG);
      widget.setAttribute('widget-id', WIDGET_ID);
      document.body.appendChild(widget);
    }

    // Load the AI Studio loader script once. Once the custom element is defined,
    // the tag upgrades automatically whenever it is (re)added to the DOM.
    if (!document.getElementById(LOADER_ID)) {
      const script = document.createElement('script');
      script.id = LOADER_ID;
      script.src = LOADER_SRC;
      script.async = true;
      document.body.appendChild(script);
    }

    // The bot switcher unmounts this component when another bot is selected.
    // Remove the widget element so the 8x8 widget disappears along with it.
    return () => {
      document.querySelectorAll(WIDGET_TAG).forEach((node) => node.remove());
    };
  }, []);

  return null;
}

export default EightByEightBot;
